import React from 'react';
import ReactGA from 'react-ga';
import createHistory from 'history/createBrowserHistory'

import './App.scss';
import './colors.css';
import DashboardLayout from './layout/Dashboard/DashboardLayout';
import StandaloneLayout from './layout/Standalone/StandaloneLayout';
import WidgetLayout from './layout/Widget/WidgetLayout';
import {Redirect, Router, Switch, Route} from 'react-router-dom';
import { DASHBOARD_BASE_PATH, STANDALONE_PAGE_PATH, SSO_PATH, WIDGET_BASE_PATH } from './constants/paths';
import configureStore from './layout/appStore';
import { Provider } from 'react-redux';
import ErrorMain from './components/common/Error/ErrorMain';
import {setMixpanelSuperProperties} from './helpers/analyticsHelper';
import { createMuiTheme } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import { LastLocationProvider } from 'react-router-last-location';
import { GA_TRACKING_ID, MOUSEFLOW_PROJECT_ID } from './constants/configs';
import SsoAuthenticationLayer from './components/samlSSO/SsoAuthenticationLayer';
import { addMouseflowTracker } from './helpers/mouseflowHelper';
import { Configuration } from './configs/Configuration';
import { addPickMySolar } from './helpers/pickMySolarHelper';

if(MOUSEFLOW_PROJECT_ID && MOUSEFLOW_PROJECT_ID !== ""){
  let configs = Configuration.getConfiguration();
  addMouseflowTracker(MOUSEFLOW_PROJECT_ID, configs.pilotId);
}
const history = createHistory()
ReactGA.initialize(GA_TRACKING_ID);
history.listen((location, action) => {
    ReactGA.pageview(location.pathname + location.search);
});
addPickMySolar();
function App() {
  setMixpanelSuperProperties();
  const theme = createMuiTheme({
    typography: {
      fontFamily: [
        'Montserrat',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
      ].join(','),
    },
    props: {
      MuiButtonBase: {
        disableRipple: true, // No more ripple, on the whole application!
      },
    }
  });

  return (
    <ThemeProvider theme={theme}>
      <div className="app">
        <Router history={history}>
          <LastLocationProvider>
            <Switch>
              <Redirect exact from="/" to={DASHBOARD_BASE_PATH} />
              <Route exact path={SSO_PATH} component={SsoAuthenticationLayer}></Route>
              <Route path={DASHBOARD_BASE_PATH} >
                <Provider store={configureStore('Dashboard')}>
                  <DashboardLayout />
                </Provider>
              </Route>
              <Route path={WIDGET_BASE_PATH} >
                <Provider store={configureStore('Dashboard')}>
                  <WidgetLayout />
                </Provider>
              </Route>
              <Route path={STANDALONE_PAGE_PATH} >
                <Provider store={configureStore('Standalone')}>
                  <StandaloneLayout />
                </Provider>
              </Route>
              <Route component={ErrorMain} />
            </Switch>
          </LastLocationProvider>
        </Router>
      </div>
    </ThemeProvider>
  );
}

export default App;
